import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";

export default function FormLangue(props){
    return(
        <div style={{textAlign : 'start', background:'#f1f4fa', marginTop:5, border:'1px solid rgba(0, 0, 0, 0.1)', borderRadius:'20px', padding:'10px'}}>
            <br />
            <p style={{textAlign:'start'}} className='p titre-steep'>Vous parlez plusieurs langues ?</p>
            <p style={{textAlign:'start'}} className='p sub-titre-steep'>Incluez votre niveau pour chacune d'entre elles.</p>
            <br/>

            {props.langues.map((langue, index) => (
                <div className="row"  key={index}>

                    {index > 0 ?
                        <div className="col-12" style={{marginTop:'10px'}}>
                            <p href="#" style={{fontWeight:'700' ,color:'red', textAlign:'end'}}  onClick={() => props.onSupprimerLangue(index)}>
                                X 
                            </p>
                            
                        </div>
                        : null
                    }

                    <div className="col-6">
                        <span style={{fontWeight: "900"}}>Langue</span>
                        <Form.Select value={langue.nomLangue} onChange={(e) => props.onChangeLangue(index, 'nomLangue', e.target.value)}
                            id="langue" className="form-control">
                            <option   ></option>
                            <option value="Arabe">Arabe</option>
                            <option value="Français">Français </option>
                            <option value="Anglais">Anglais </option>
                            <option value="Espagnol">Espagnol </option>
                            <option value="Turc">Turc </option>
                            <option value="Chinois">Chinois </option>
                            <option value="Russe">Russe </option>
                            <option value="Allemand">Allemand</option>
                            <option value="Portugais">Portugais</option>
                            <option value="Hindi">Hindi</option>
                        </Form.Select>
                        {langue.nomLangue === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgErrLangue}</p> : null}
                    </div>
                    <div className="col-6">
                        <span style={{fontWeight: "900"}}>Niveau</span>
                        <Form.Select value={langue.niveauLangue} onChange={(e) => props.onChangeLangue(index, 'niveauLangue', e.target.value)} id="niveauLangue" className="form-control">
                            <option   > </option>
                            <option value="Maternelle">Maternelle </option>
                            <option value="Courant">Courant </option>
                            <option value="Bon niveau">Bon niveau </option>
                            <option value="Intermédiaire">Intermédiaire </option>
                            <option value="Débutant">Débutant </option>
                        </Form.Select>
                        {langue.niveauLangue === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgErrLangue}</p> : null}
                    </div>
                    
                </div>
            ))}

            <div style={{marginTop:'10px'}}>
                <p onClick={props.handleAjouterLangue} style={{fontWeight:'700', fontSize:'15px', color:'red', textAlign:'start'}}>
                    <FontAwesomeIcon icon={faPlus} />  Ajouter une autre langue                        

                </p>                             
            </div>
            <br />
        </div>
    )
}